import React from "react"
import { NavDropdown, Col, Row } from "react-bootstrap"
import DropDownItemImage from "./DropDownItemImage"
import { Link } from "gatsby"

const getLinkProps = (url) =>
  url.startsWith("/") ? { to: url, as: Link } : { href: url , target:"_blank"}

const HeaderDropdownItem = ({ item }) => {
  const linkIconStyle = {
    maxWidth: '20px',
    maxHeight: '20px',
  }
  const { title, links, imageVariant, linkIcon, linkIconAlt } = item
  return (
    <Row className="dropdown-heading-container">
      <Col className="px-0">
      {title && (
        <Row className="dropdown-item-heading " >
          <div>
          {imageVariant && (
              <DropDownItemImage variant={imageVariant} />
          )}
          {linkIcon && (
              <img src={linkIcon} style={linkIconStyle} alt={linkIconAlt} />
          )}
          </div>
          <Col className="pl-3">
          <span>{title}</span>
          </Col>
        </Row>
      )}
      {links.map((link) => {
        const className = link.imageVariant || link.linkIcon ? "d-flex align-items-center" : ""
        const hrefProps = getLinkProps(link.url)
        return (
          <NavDropdown.Item {...hrefProps} className={className}>
              {link.imageVariant && (
                <DropDownItemImage variant={link.imageVariant} />
              )}
              {link.linkIcon && (
                <img src={link.linkIcon} style={linkIconStyle} alt={linkIconAlt} />
              )}
            <div className={`${link.imageVariant || link.linkIcon ? "pl-3" : ""} link-subtitle`}>
              <p className="mb-0">{link.title}</p>
              <span>{link.description}</span>
            </div>
          </NavDropdown.Item>
        )
      })}
      </Col>
    </Row>
  )
}

export default HeaderDropdownItem
